"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _Feedback = _interopRequireDefault(require("@material-ui/icons/Feedback"));
var _classnames = _interopRequireDefault(require("classnames"));
var _excluded = ["onSure", "className"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var promiseStatus = {
  pending: 'PENDING',
  resolved: 'RESOLVED',
  rejected: 'REJECTED'
};
var _default = exports["default"] = function _default(_ref) {
  var onSure = _ref.onSure,
    className = _ref.className,
    otherProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    hovered = _useState2[0],
    setHovered = _useState2[1];
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  var _useState3 = (0, _react.useState)(null),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    status = _useState4[0],
    setStatus = _useState4[1];
  var lastValueRef = (0, _react.useRef)();
  var handleFeedback = function handleFeedback(helpful) {
    lastValueRef.current = helpful;
    setStatus(promiseStatus.pending);
    onSure(helpful).then(function () {
      return setStatus(promiseStatus.resolved);
    })["catch"](function (e) {
      return setStatus(promiseStatus.rejected);
    });
  };
  var contentStatus = function contentStatus(currStatus) {
    switch (currStatus) {
      case promiseStatus.pending:
        return /*#__PURE__*/_react["default"].createElement("span", {
          className: "font-semibold text-gray-light pr-2"
        }, t('smartReply.feedback.sending'));
      case promiseStatus.resolved:
        return /*#__PURE__*/_react["default"].createElement("span", {
          className: "font-semibold text-gray-light pr-2"
        }, t('smartReply.feedback.sendSuccess'));
      case promiseStatus.rejected:
        return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("span", {
          className: "font-semibold text-gray-light"
        }, t('smartReply.feedback.sendFailure')), /*#__PURE__*/_react["default"].createElement("button", {
          className: "text-primary p-2",
          onClick: function onClick() {
            return handleFeedback(lastValueRef.current);
          }
        }, t('button.tryAgain')));
      default:
        return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("span", {
          className: "font-semibold text-gray-light"
        }, t('smartReply.feedback.toast')), /*#__PURE__*/_react["default"].createElement("button", {
          className: "text-primary p-2",
          onClick: function onClick() {
            return handleFeedback(true);
          }
        }, t('button.yes')), /*#__PURE__*/_react["default"].createElement("button", {
          className: "text-primary p-2 pr-4",
          onClick: function onClick() {
            return handleFeedback(false);
          }
        }, t('button.no')));
    }
  };
  var content = hovered ? contentStatus(status) : null;
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, otherProps, {
    className: (0, _classnames["default"])("inline-flex items-center text-sm whitespace-no-wrap bg-card dark:bg-secondary", {
      'rounded-lg': hovered,
      'rounded-full': !hovered
    }, className),
    style: {
      boxShadow: '0 3px 3px 0 rgba(0, 0, 0, 0.1), 0 0px 2px 0 rgba(0, 0, 0, 0.06)',
      marginRight: hovered ? 0 : 196
    },
    onMouseEnter: function onMouseEnter() {
      return setHovered(true);
    },
    onMouseLeave: function onMouseLeave() {
      return (!status || status === promiseStatus.resolved) && setHovered(false);
    }
  }), /*#__PURE__*/_react["default"].createElement(_Feedback["default"], {
    className: "text-gray-light m-2"
  }), content);
};
//# sourceMappingURL=index.js.map